"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSelector = exports.useAppDispatch = exports.persistor = exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const redux_1 = require("redux");
const redux_persist_1 = require("redux-persist");
const react_redux_1 = require("react-redux");
const authSlice_1 = __importDefault(require("./features/auth/authSlice"));
const homeSlice_1 = __importDefault(require("./features/home/homeSlice"));
const loanApplicationSlice_1 = __importDefault(require("./features/loanApplication/loanApplicationSlice"));
const surveySlice_1 = __importDefault(require("./features/survey/surveySlice"));
const middlewareUtils_1 = require("./utils/middlewareUtils");
const reducers = (0, redux_1.combineReducers)({
    // auth
    auth: authSlice_1.default,
    // home
    home: homeSlice_1.default,
    // loan application
    loanApplication: loanApplicationSlice_1.default,
    survey: surveySlice_1.default,
});
const persistConfig = {
    key: 'root',
    storage: async_storage_1.default,
    whitelist: ['auth'],
};
const persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig, reducers);
exports.store = (0, toolkit_1.configureStore)({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(middlewareUtils_1.authInterceptor /* logger */),
});
exports.persistor = (0, redux_persist_1.persistStore)(exports.store);
const useAppDispatch = () => (0, react_redux_1.useDispatch)();
exports.useAppDispatch = useAppDispatch;
exports.useAppSelector = react_redux_1.useSelector;
